import React, { useState, useEffect } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid } from '@material-ui/core';
import TransitionsModal from '../Modal';
import { getAllPM_plans } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const Rescheduleplan = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: ' Preventive Maintenance', href: '/preventive-maintenance' }
    ];
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [plan, setPlan] = useState();
    const [allplans, setAllplans] = useState();
    const Role = localStorage.getItem("userRole");

    const planHandler = (plan) => {
        if (Role === 'admin' || Role === 'supplier') {
            setOpen(true)
            setPlan(plan);
        } else {
            toast.info("You don't have access to do this activity!")
        }

    }

    const handleClose = () => {
        setOpen(false);
    };

    const getAllplans = async () => {
        try {
            const action = dispatch(getAllPM_plans());
            const res = await action.unwrap();
            setAllplans(res.result.pm_plan);
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            await getAllplans();
            setLoading(false);
        };
        fetchData();
    }, [])

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center">
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }


    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Reschedule Plan" />
                </Box>
                <Box>
                    {allplans && allplans.length === 0 ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                            <Typography variant="h5">No Plan created</Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={3}>
                            {allplans && allplans.map((plan, index) => (
                                <Grid item className='PM' xs={12} sm={3} key={index}>
                                    <div className='card' onClick={() => { planHandler(plan) }}
                                    >
                                        {/* Conditionally render the submitted batch if the status is approval-pending */}
                                        {plan.reschedule_date && (
                                            <div style={{
                                                backgroundColor: 'brown',
                                                color: 'white',
                                                padding: '5px',
                                                borderRadius: '5px',
                                                marginBottom: '10px'
                                            }}>
                                                Rescheduled
                                            </div>
                                        )}
                                        <p>{plan.assetMaster_details.asset_text} ({plan.assetMaster_details.asset_no})</p>
                                        {/* <p>RFID No: {plan.rfidNo}</p> */}
                                        {/* <p>Part No: {plan.assetMaster_details.part_no}</p> */}
                                        <h4>Maintenance</h4>
                                        <p>Frequency: {plan.frequency}</p>
                                        <p>Total CheckPoints: {plan.total_checkpoints}</p>
                                        <p>{plan.start_date}</p>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>
                    )
                    }
                    {/* <Grid container spacing={3}>
                        {plans.map((plan, index) => (
                            <Grid item className='PM' xs={6} sm={3} key={index}>
                                <div className='card' onClick={() => { planHandler(plan) }}>
                                    <p>{plan.assetDescription} ({plan.assetNo})</p>
                                    <h4>Maintenance</h4>
                                    <p>Frequency: {plan.frequency}</p>
                                    <p>Total CheckPoints:</p>
                                    <p>{plan.startDate}</p>
                                </div>
                            </Grid>
                        ))}
                    </Grid> */}
                </Box>
                <TransitionsModal open={open} handleClose={handleClose} selectedPlan={plan} plan="Rescheduleplan" />
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default Rescheduleplan;
